"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _help_2_chat = _interopRequireDefault(require("../images/help_2_chat.gif"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var chattingWindow = {
  id: "chattingWindow",
  title: {
    en: "Chatting Window",
    de: "Chat-Fenster"
  },
  content: {
    en: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("img", {
      src: _help_2_chat.default,
      alt: "",
      style: {
        width: "390px",
        height: "274px",
        display: "block",
        margin: "16px auto"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FCA610"
      }
    }, "Chatting window"), /*#__PURE__*/_react.default.createElement("p", null, "Chatting window has [normal][yell][party][guild][wishper][system][damage] so that you can press each button to turn on or off. You can turn on applied chatting by R-Click."), /*#__PURE__*/_react.default.createElement("p", null, "Also, each chatting mode can separate into different windows. As you left click on your mouse and move out of the chatting window, chatting window will separate is possible. Same method you can also combine and go back to previous mode."), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Normal(normal conversation)"), "Normal response and chat with other users.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Yell(To Yell)"), "It can travel further than normal chat.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Party (To chat with party)"), "A method of chatting where only party members can listen.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Guild(talk to guild)"), "Type of conversation where only guild members can listen. You must join in order to use.")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "Whispering(1on1 conversation)"), "This is specially for users to talk to each other. To use (/wishper user then dialog).")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "#FFFFFF"
      }
    }, "System(Game progress message)"), "Chatting window where game progress is posted."))), /*#__PURE__*/_react.default.createElement("p", {
      style: {
        color: "#774C0E"
      }
    }, "Reference) Easy micro chatting operation: Use of command", /*#__PURE__*/_react.default.createElement("ol", null, /*#__PURE__*/_react.default.createElement("li", null, "Click command at the social menu located at main menu."), /*#__PURE__*/_react.default.createElement("li", null, "Press any empty button once then click, press EDIT button below."), /*#__PURE__*/_react.default.createElement("li", null, "At the title input 8 letter or less words. Ex)Increase"), /*#__PURE__*/_react.default.createElement("li", null, "Content 1 input your chatting content. Ex) Hello."), /*#__PURE__*/_react.default.createElement("li", null, "After checking press added chatting micro button and then put it at shortcut slot to use."))))
  }
};
var _default = chattingWindow;
exports.default = _default;